module.exports = __webpack_public_path__ + "img/STERiGLIDE_00_04.4576f277.png";